import du from '../utils/dom-utilities';

/**
 * Accordion Initialisation
 *
 * @param {String} accordion - Accordion wrapper className
 * @param {String} accordionTab - Accordion Tab className
 * @param {String} accordionPanel - Accordion Panel className
 * @return {Listenner} - Set listenner on accordionTab click action
 */
export default (
    accordion = '.js-accordion',
    accordionTab = '.js-accordion__tab',
    accordionPanel = '.js-accordion__panel') => {

        if (!accordion) {
            throw new Error('accordion should not be null.');
        }

        if (!accordionTab) {
            throw new Error('accordionTab should not be null.');
        }

        if (!accordionPanel) {
            throw new Error('accordionPanel should not be null.');
        }


        accordion = document.querySelector(accordion);

        const accordionTabs = du.queryAll(accordionTab);
        const accordionPanels = du.queryAll(accordionPanel);

        if (!accordion || !accordionTabs || !accordionPanels) {
            return;
        }

        accordionTabs.forEach((tab) => {
            tab.addEventListener('click', function(event) {
                event.preventDefault();

                accordionTabs.forEach((tab) => tab.classList.remove('accordion__tab--is-active'));
                accordionPanels.forEach((panel) => {
                    panel.classList.remove('accordion__panel--is-active');
                });

                let targetTab = event.target;
                let targetPanel = null;

                if (event.target.nodeName !== 'BUTTON') {
                    targetTab = du.getClosest(targetTab, 'button');
                    targetPanel = document.querySelector(targetTab.getAttribute('data-id'));
                } else {
                    targetPanel = document.querySelector(targetTab.getAttribute('data-id'));
                }

                targetTab.classList.add('accordion__tab--is-active');
                targetPanel.classList.add('accordion__panel--is-active');
            });
        });
};



// WEBPACK FOOTER //
// ./src/main/js/components/accordion.js